import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { ESTRATEGIAS } from "../types/constants/estrategias";

interface SelectEstrategiaProps {
    value: string;
    onChange: (value: string) => void;
    label?: string;
    fullWidth?: boolean;
    sx?: any;
}

const SelectEstrategia = ({
    value,
    onChange,
    label = "Estratégia",
    fullWidth = true,
    sx = {}
}: SelectEstrategiaProps) => {

    const handleChange = (event: SelectChangeEvent) => {
        onChange(event.target.value as string);
    };

    return (
        <FormControl fullWidth={fullWidth} sx={sx}>
            <InputLabel id="estrategia-label">{label}</InputLabel>
            <Select
                labelId="estrategia-label"
                id="estrategia"
                value={value}
                label={label}
                onChange={handleChange}
            >
                <MenuItem key={-1} value="">
                    Todas
                </MenuItem>
                {ESTRATEGIAS.map((estrategia, index) => (
                    <MenuItem key={index} value={estrategia.nome}>
                        {estrategia.nome}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default SelectEstrategia;
